import { createTheme, type Theme } from "@mui/material/styles";
import { defaultLightTheme, defaultDarkTheme, type RaThemeOptions } from "react-admin";

// Fix horizontal scroll on browser zoom:
// 1. RaLayout-root has min-width: fit-content — override to 0
// 2. RaLayout-content (#main-content) flex item needs min-width: 0 to shrink within viewport
// 3. MuiTableCell below xl: nowrap keeps every cell on one line so the table keeps its natural width and TableContainer scrolls horizontally; at xl and up cells wrap (word-break) so wide tables fit the page
const overrides: RaThemeOptions = {
  components: {
    RaLayout: {
      styleOverrides: {
        root: {
          minWidth: 0,
          "& .RaLayout-content": {
            minWidth: 0,
          },
        },
      },
    },
    // Утилитарный класс числовых колонок: моноширинные цифры выравнивают разряды
    // друг под другом. Объявлен один раз в теме, чтобы у каждой таблицы был один
    // и тот же способ его получить.
    MuiCssBaseline: {
      styleOverrides: {
        ".tabular-nums": {
          fontVariantNumeric: "tabular-nums",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: ({ theme }: { theme: Theme }) => ({
          wordBreak: "break-word",
          overflowWrap: "break-word",
          whiteSpace: "nowrap",
          [theme.breakpoints.up("xl")]: {
            whiteSpace: "normal",
          },
        }),
      },
    },
  },
};

export const lightTheme = createTheme(defaultLightTheme, overrides);
export const darkTheme = createTheme(defaultDarkTheme, overrides);
